// extracted by mini-css-extract-plugin
export var box = "_3e-0";
export var check = "_3e-1";
export var checkboxButton = "_3e-6";
export var checkboxGroup = "_3e-5";
export var disabled = "_3e-7";
export var ghost = "_3e-9";
export var input = "_3e-2";
export var label = "_3e-4";
export var normal = "_3e-8";
export var uncheck = "_3e-3";